export const SIGNIN = "SIGNIN";

export const EMPTYP = "employeeType";
export const DEP = "deparatment";
export const ID = "id";
export const FNAME = "firstName";
export const LNAME = "lastName";
export const EMAIL = "email";
export const PASSWORD = "password";
export const CPASSWORD = "confirmPassword";
export const ADDRESS = "address";
export const PHONENO = "phoneNumber";
export const DESIGNATION = "designation";

